import React, { useEffect, useState } from 'react';
import { Box, Card, Typography, List, ListItemButton, Tooltip } from '@mui/material';
import { FaStar, FaHistory, FaPlus, FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';
import { useGetLastReads } from '../../../hooks/useGetLastReads';
import "./Sidebar.css";
import { useGetLatestCreated } from '../../../hooks/useGetLatestCreated';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const Sidebar = ({ isSidebarMinimized, toggleSidebar }) => {
  const [lastReads, setLastReads] = useState([]);
  const [latestCreated, setLatestCreated] = useState([]);
  const navigate = useNavigate();


  const { isError: isLastReadError, isSuccess: isLastReadSuccess, data: LastReadData } = useGetLastReads();
  const { isError: isLatestError, isSuccess: isLatestCreatedSuccess, data: LastCreatedData } = useGetLatestCreated();


  const limitCharacters = (text, maxChars) => {
    if (text.length > maxChars) {
      return `${text.slice(0, maxChars)}...`;
    }
    return text;
  };

  useEffect(() => {
    setLastReads(LastReadData?.lastReads || []);
    setLatestCreated(LastCreatedData?.latestCreated || []);

    // return axios.get(`/api/user/last/reads`).then(res => res.data);

  }, [LastReadData, LastCreatedData]);

  return (
    <Box display="flex" flexDirection="column" height="100vh" bgcolor="#f5f5f5">
      {!isSidebarMinimized && (
        <Card variant="outlined" sx={{ flexGrow: 1, overflowY: 'auto', padding: 2 }}>
          {/* Recent Readings */}
          <Box mb={2}>
            <Typography variant="h6" sx={{fontSize:'15px', fontWeight:'600'}}  color="primary" display="flex" alignItems="center">
              <FaHistory className="me-2" />
              Recent Readings
            </Typography>
            <List>
              {latestCreated.length > 0 ? (
                lastReads?.map((page) => (
                  //need to make tooltip
                  <Tooltip title={page.pages.title} placement="right" arrow key={page.pages.id}>
                    <ListItemButton key={page.pages.id} onClick={() => navigate(`/page/content/${page.pages.id}/${page.pages.slug}`)} sx={{ justifyContent: 'flex-start', padding: '7px 14px', '&:hover': { backgroundColor: '#e0e0e0' } }}>
                      <Typography variant="body2" className='list-text'>{limitCharacters(page.pages.title, 32)}</Typography>
                    </ListItemButton>
                  </Tooltip>
                ))
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No page Reads Yet.
                </Typography>
              )}


            </List>
          </Box>

          {/* Recently Created */}
          <Box mb={2}>
            <Typography variant="h6" sx={{fontSize:'15px', fontWeight:'600'}} color="success.main" display="flex" alignItems="center">
              <FaPlus className="me-2" />
              Recently Created
            </Typography>
            <List>
              {latestCreated.length > 0 ? (
                latestCreated.map((page) => (
                  <Tooltip title={page.title} placement="right" arrow key={page.id}>
                    <ListItemButton
                      key={page.id}
                      sx={{ justifyContent: 'flex-start', padding: '7px 14px', '&:hover': { backgroundColor: '#e0e0e0' } }}
                      onClick={() => navigate(`/page/content/${page.id}/${page.slug}`)}
                    >
                      <Typography variant="body2" className="list-text">
                        {limitCharacters(page.title, 32)}
                      </Typography>
                    </ListItemButton>
                  </Tooltip>
                ))
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No page Created Yet.
                </Typography>
              )}

            </List>
          </Box>

          {/* Favorites future dev*/}
        </Card>
      )}
    </Box>
  );
};

export default Sidebar;
